import React from "react"
import { Tooltip } from "react-bootstrap"

const sketchyTooltip = (text: string) => (
    <Tooltip id={`sketchy-tooltip`}>
        {text}
    </Tooltip>
)

export default sketchyTooltip